// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6cc48eab","455":"1e8cee7c","977":"5c4f4419"}[chunkId] + ".chunk.js";
};